import moment from 'moment';
import {MODULE_ID} from 'food-benefit.module/common/domain/constants';

class ModalCancelDelegationController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    this.startDate = new Date(this.delegation.startDate);
    this.employeeId = this.delegation.employeeId;
    this.delegatePerson = this.delegation.name;
    this.delegateDate = this.formatDate(this.delegation.startDate) + ' - ' + this.formatDate(this.delegation.endDate);

    this.data = {
      startDate: this.startDate,
      employeeId: this.employeeId,
    };

    if (this.delegation.type === MODULE_ID) {
      this.permissionType = this.delegation.type;
      this.hasPermissionType = true;
    }

    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  send() {
    let event = this.EventEmitter(this.data);
    this.cancelDelegation(event);
  }

  formatDate(date, lang = 'es') {
    moment.locale(lang);
    let result = moment(date).format('DD MMMM YYYY');
    return result;
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.ACCEPT'
      }, {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

}

export default ModalCancelDelegationController;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalCancelDelegation/modalCancelDelegation.controller.js